import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchFederalProformaTypes = getApiActionTypes('FEDERAL_PROFORMA/FETCH');
export const checkLastRefreshProFormaReturnTypes = getApiActionTypes(
  'FEDERAL_PROFORMA/CHECK_LAST_REFRESH_PRO_FORMA_RETURN',
);
